
import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router";

import { Loader } from '../../helpers/loader';
import { useHistory, useLocation } from 'react-router-dom';

import { supabase } from '../../api'
import { DebounceInput } from 'react-debounce-input';
import cloneDeep from 'clone-deep';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faFile, faPencilAlt, faMinus, faPrint, faReceipt, faBars, faListCheck, faVideoCamera, faSearch, faWarning, faCheck, faSquare, faSquareCheck, faClose, faBook } from '@fortawesome/free-solid-svg-icons'

import { ELNStore } from '../../store'
import useModal from "../../helpers/useModal";
import RecipeForm from "../../components/RecipeForm";
import Modal from '../../components/Modal';
import { cleanPID, DISH_PID_ADD, formatDate, formatDateWithYear, fullRecipeType, plural, RECIPE_PID_ADD, wait } from "../../helpers/utils";
import Photo from "../../components/Photo";

import Calendar from "react-calendar";
import { recipesFilteredByType, recipesFilteredByOthers, isMatch, recipeName, spaces, arrayOfNums, calculateWarnings, getCombinedIngredients, getRandom, Allergen, Logo, getAllergensForRecipe, ROUNDING_FACTOR, showQuantity } from './specCardsHelpers'
import Pagination from './components/Pagination'
import { Traceability } from "./components/Traceability";
import { IngredientTable } from "./components/IngredientTable";
import { LookBook } from "./components/LookBook";
import { Label } from "./components/Label";

const MAX_TO_SHOW = 100
const PAGE_SIZE = 50





const RecipeTable = ({title, recipes, showTotalQuantity, showIngredientUnits}) => {

  return <div>
    <h2>{recipes.length} {title}</h2>
    <table>
      <thead>
        <th>PID</th>
        <th>Name</th>
        <th>Type</th>
        <th>Quantity</th>
        <th>Unit</th>
        <th>Num ingredients</th>
        {showTotalQuantity &&<th>Total quantity of ingredients</th>}
        {showTotalQuantity &&<th>% Diff</th>}
        {showIngredientUnits && <th>Ingredient Units</th>}
      </thead>
    <tbody>
      {recipes.map(w => <tr key={w.pid}>
        <td>{w.pid}</td>
        <td>{w.name}</td>
        <td>{w.type}</td>
        <td>{w.quantity}</td>
        <td>{w.quantity_unit}</td>
        <td>{w.ingredients?.length || 0}</td>
        {showTotalQuantity && <td>{w.ingredients?.map(i => i.quantity).reduce((a, b) => a + b, 0)}</td>}  
        {showTotalQuantity && <td>{w.perc}</td>}
        {showIngredientUnits && <td>{w.ingredients?.map(i => `${i.quantity_unit || '[X]'},`)}</td>}
      </tr>)}
    </tbody>
  </table>
  <br/>
  </div>
}

export const SpecCards = ({ match }) => {

  const { showModal: showEditModal, toggleModal: toggleEditModal } = useModal()
  const { showModal: showLabelModal, toggleModal: toggleLabelModal } = useModal()

  const { showModal: showCardModal, toggleModal: toggleCardModal } = useModal()
  const { showModal: showCalModal, toggleModal: toggleCalModal } = useModal()
  const { showModal: showVideoModal, toggleModal: toggleVideoModal } = useModal()
  const { showModal: showExcludeModal, toggleModal: toggleExcludeModal } = useModal()

  const history = useHistory();
  const location = useLocation();

  const defaultSearch = match.params.search ? decodeURIComponent(match.params.search).toUpperCase() : ''

  const [loading, setLoading] = useState(true)

  const [mthCutoff, setMthCutoff] = useState(0)

  const [item, setItem] = useState()

  const [lastImported, setLastImported] = useState()

  const [filter, setFilter] = useState('S')
  const [types, setTypes] = useState('A')

  const [selectedDate, setSelectedDate] = useState(new Date())

  const storedRecipes = ELNStore.useState(s => s.recipes);
  const currentUser = ELNStore.useState(s => s.currentUser);

  const [recipe, setRecipe] = useState()

  const [recipes, setRecipes] = useState(storedRecipes)
  const [search, setSearch] = useState(defaultSearch || '')

  const excludeLocal = localStorage.getItem('exclude')

  const [exclude, setExclude] = useState(excludeLocal || '')

  const [filteredRecipes, setFilteredRecipes] = useState([])
  const [excludeCount, setExcludeCount] = useState(0)
  const [matchType, setMatchType] = useState('')

  const [page, setPage] = useState(0)

  const [cardView, setCardView] = useState('DEFAULT')

  const [multiplier, setMultiplier] = useState(1)
  const [multiplierRecipe, setMultiplierRecipe] = useState()

  const [excludeSubs, setExcludeSubs] = useState([])

  

  const handleCalendarChange = async (val) => {
    toggleCalModal()
    setSelectedDate(val)
  }

  

  const [random, setRandom] = useState(getRandom())

  const updateRandom = () => {
    setRandom(getRandom())
  }


  const allRecipes = []

  const processRecipeHierarchy = (level, recipe, ingredient) => {

    const isExcluded = excludeSubs.includes(recipe.pid)
    if (isExcluded) return recipe

    let ratioRequired = 1
    if (ingredient) {
      ratioRequired = (ingredient.quantity_adjusted || ingredient.quantity) / recipe.quantity
    }

    const enhancedIngredients = recipe?.ingredients && [...recipe.ingredients].reverse().map(i => {
      const ingredient_recipe = recipes.find(r => r.pid === i.child_pid)
      const enhancedIngredient = { ...i, quantity_adjusted: i.quantity * ratioRequired }
      return { ...enhancedIngredient, recipe: processRecipeHierarchy(level + 1, ingredient_recipe, enhancedIngredient) }
    })

    const enhancedRecipe = cloneDeep({ ...recipe, level, quantity_adjusted: recipe.quantity * ratioRequired, ingredients: enhancedIngredients.reverse() })
    
    
    if (enhancedRecipe.type !== 'P') allRecipes.push(enhancedRecipe)

    if (!enhancedRecipe.quantity && enhancedRecipe.type === 'D') {
      enhancedRecipe.quantity = 1
      enhancedRecipe.quantity_adjusted = 1
      enhancedRecipe.quantity_unit = 'dish'
    }

    return enhancedRecipe
  }

  if (recipe) processRecipeHierarchy(0, recipe)

  allRecipes.reverse();

  const openCardModal = (recipe) => {
    setRecipe(recipe)
    if (!showCardModal && recipe && recipe.type !== 'P') toggleCardModal()
  }

  useEffect(() => {
    if (!recipe) return

    setExcludeSubs([])
    //const recipesWithQuantity = allRecipes.filter(r => !!r.quantity)
    setMultiplier(1)
    setMultiplierRecipe(allRecipes?.[0])

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recipe])

  const setMini = () => {
    setExcludeSubs([])
    setCardView('MINI')
  }

  const setDefault = () => {
    setExcludeSubs([])
    setCardView('DEFAULT')
  }

  const setTraceability = () => {
    setExcludeSubs([])
    setCardView('TRACEABILITY')
  }

  const setLookbook = () => {
    setExcludeSubs([])
    setCardView('LOOKBOOK')
  }

  const mini = cardView !== 'DEFAULT'

  const isStep = (step) => {
    return step.txt.match(/^([0-9]+)\|.*/)
  }


  useEffect(() => {

    setPage(0)

  }, [filteredRecipes, filter, types])


  useEffect(() => {
    async function initialize() {

        setLoading(true)

        //const cutOffDate = new Date();
        //cutOffDate.setMonth(cutOffDate.getMonth() - mthCutoff);
        
        const query1 = supabase
          .from('recipes')
          .select('*, steps (*), ingredients!ingredients_parent_pid_fkey (*))')
          .order('position', { foreignTable: "ingredients", ascending: true }).range(0, 8000)

        const query2 = supabase
          .from('recipes')
          .select('*, steps (*), ingredients!ingredients_parent_pid_fkey (*))')
          .order('position', { foreignTable: "ingredients", ascending: true }).range(8001, 16000)

        //if (mthCutoff > 0) {
        // CANT DO THIS AS WE WONT HAVE RELATIONS - ALL RECORDS NEED TO BE LOADED
        //  query1.gte('last_ordered', cutOffDate.toISOString());
        //  query2.gte('last_ordered', cutOffDate.toISOString());
          
        //}
        const { data: recipes1, error: recipesErr1 } = await query1
        const { data: recipes2, error: recipesErr2 } = await query2


        const recipes = [...recipes1, ...recipes2]

        
        /* THIS BREAKS!!!!!!!!
        recipes.forEach(r => {
            if (r.ingredients?.length) {
              const i = r.ingredients.sort((a,b) => a.child_pid > b.child_pid ? 1 : -1).map(j => j.child_pid).join(":")
              r.i = i
            }
        })

        recipes.forEach(r => {
            const copies = r.ingredients?.length ? recipes.filter(c => c.pid !== r.pid && c.i === r.i) : []
            r.duplicates = copies
        })
        */

        const correctedRecipes = calculateWarnings(recipes)

        setRecipes(correctedRecipes)
        ELNStore.update(s => { s.recipes = recipes })

        filterRecipes(correctedRecipes, search)
        
        setLoading(false)
      }


    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  useEffect(() => {   
    setFilter('A')
  }, [types])



  useEffect(() => {
    // get pid from location

    if (recipes) {
      const dt = recipes.filter(r => r.imported_at).sort((a, b) => (a.imported_at < b.imported_at ? 1 : -1))[0]
      setLastImported(dt.imported_at)
    }
  }, [recipes]);

  useEffect(() => {

    // get pid from location
    const pid = parseInt(location.pathname.split('/').pop())
    if (pid && recipes) {
      const selectedRecipe = recipes.find(r => r.pid === pid)
      openCardModal(selectedRecipe)

    }
  }, [location]);


  useEffect(() => {

    if (showCardModal) document.body.classList.add('no-print-root');
    else document.body.classList.remove('no-print-root');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCardModal])

  useEffect(() => {
    if (defaultSearch === search) return
    setMthCutoff(0)
    updateSearch(defaultSearch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSearch])

  useEffect(() => {
    filterRecipes(recipes, search)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mthCutoff])


  if (!currentUser) return null


  const handleChangeSearch = (e) => {
    const search = e.target.value.toUpperCase()
    history.push(`/spec-cards/${search}`)
  }

  const handleChangeExclude = (e) => {
    const exclude = e.target.value.toUpperCase()
    setExclude(exclude)
  }

  const updateExclude = () => {
    toggleExcludeModal()
    localStorage.setItem('exclude', exclude)
    filterRecipes(recipes, search)
  }

  const updateSearch = (txt) => {
    setSearch(txt.toUpperCase())

    if (!txt.length) setFilter('A')
    filterRecipes(recipes, txt)
  }

  

  const filterRecipes = (recipes, search) => {

    setLoading(true)
    if (!recipes) return

    let results = []
    if (!search || search.length === 0) {
      results = recipes
      setMatchType('')
    }
    else if (search.startsWith('USES ')) { // used-in search
      setTypes('A')
      setFilter('A')
      
      const pid = parseInt(search.slice(4))
      const product = recipes.find(r => r.pid === pid || r.pid === pid + RECIPE_PID_ADD || r.pid === pid + DISH_PID_ADD)

      if (product) {
        results = recipes.filter(r => r.ingredients?.find(i => i.child_pid === product.pid))
        setMatchType(`that use: ${product.name.toUpperCase()}`)
      }
    }
    else if (isNaN(search) || parseInt(search) < 10000) {  // text search

      // split search by spaces
      const arr = search.split(' ')

      results = recipes.filter(r => isMatch(r, arr))

      setMatchType(`for '${search}'`)

    }
    else {

      search = parseInt(search)
      const match = recipes.find(r =>
        r.pid === search || r.pid === search + DISH_PID_ADD || r.pid === search + RECIPE_PID_ADD || r.pid === search - DISH_PID_ADD || r.pid === search - RECIPE_PID_ADD
      )

      if (match) {
        //find related
        results = [match]
        setMatchType(`for ${match.type.toLowerCase()} ${match.name.toUpperCase()}`)
      }


    }


    let cleanResults = [...results]
    

    const cutOffDate = new Date();
    cutOffDate.setMonth(cutOffDate.getMonth() - mthCutoff);

    if (mthCutoff > 0) {
      cleanResults = cleanResults.filter(r => r.last_ordered && new Date(r.last_ordered) > cutOffDate)
    }
    else if (mthCutoff === -1) {
      cleanResults = cleanResults.filter(r => !r.last_ordered)
    }

    if (exclude) {
      const beforeExcludeCount = cleanResults.length
      const excludeArr = exclude.split(',').map(e => e.trim()).filter(e => e.length)
      cleanResults = cleanResults.filter(r => !excludeArr.some(e => ` ${r.name || ''} `.toUpperCase().includes(` ${e} `)))
      const excludedCount = beforeExcludeCount - cleanResults.length
      setExcludeCount(excludedCount)
    }

    setFilteredRecipes(cleanResults)
    setTimeout(() => setLoading(false), 1000)

  }



  

  const SpecCardList = ({ recipe, allRecipes, random, updateRandom }) => {

    const dropdownRef = useRef()
    const inputRef = useRef()

    const [key, setKey] = useState(0);


    const changeDropdown = () => {
      const val = dropdownRef.current.value

      if (val === -1) {
        setMultiplierRecipe(undefined)
      }
      else {
        const arr = val.split('|')
        const recipe = allRecipes.find(r => parseInt(r.pid) === parseInt(arr[0]) && r.quantity_adjusted === Number(arr[1]))
        setMultiplierRecipe(recipe)
      }
      setKey(prev => prev + 1);
    }

    const doCalc = () => {

      const val = inputRef.current.value
      if (multiplierRecipe) {
        setMultiplier(val / multiplierRecipe.quantity_adjusted)
      }
      else {
        setMultiplier(val)
      }
    }

    const multiplierRounded = Math.round(10000 * multiplier) / 10000

    const multiplierDisplayed = multiplierRecipe ? Math.floor(ROUNDING_FACTOR * multiplierRecipe.quantity_adjusted * multiplier)/ROUNDING_FACTOR : multiplierRounded

    return (
      <>
        <div className='multipliers no-print'>
          <select ref={dropdownRef} onChange={changeDropdown} >

            {allRecipes.map((r, i) => {
              if (!r.quantity) return
              return (
                <option key={`${r.pid}|${r.quantity_adjusted}`} selected={multiplierRecipe?.pid === r.pid && multiplierRecipe?.quantity_adjusted === r.quantity_adjusted} value={`${r.pid}|${r.quantity_adjusted}`}>{spaces(r.level)}{recipeName(r).toUpperCase()} [{showQuantity(r.quantity_adjusted, multiplier, r.quantity_unit)}]</option>
              )
            })}
            <option key={-1} selected={!multiplierRecipe} value={-1}>CURRENT MULTIPLIER: {multiplierRounded}</option>
          </select><input ref={inputRef} key={key} type="number" className='multiplier' defaultValue={multiplierDisplayed} min={1} />{multiplierRecipe ? multiplierRecipe.quantity_unit : ''}&nbsp;&nbsp;&nbsp;<button className='inv' onClick={doCalc}>Update</button>
        </div>
        {cardView === 'TRACEABILITY' && <Traceability toggleCalModal={toggleCalModal}  selectedDate={selectedDate} recipes={recipes} recipe={allRecipes.find(r => r.pid === recipe.pid)} allRecipes={allRecipes} multiplier={multiplier} excludeSubs={excludeSubs} setExcludeSubs={setExcludeSubs} />}
        {mini && <Logo />}
        {allRecipes.map((r, i) => <SpecCard random={random} updateRandom={updateRandom} recipe={r} index={i} total={allRecipes.length - 1} parentRecipe={recipe} multiplier={multiplier} />)}
      </>
    )
  }

  


  const ListRow = ({ recipe }) => {

    const selectRecipe = () => {
      history.push(`/spec-cards/${search}/${recipe.pid}`)
    }

    const editItem = () => {
      setItem(recipe)
      toggleEditModal()
    }

    const allergens = getAllergensForRecipe(recipes, recipe)

    const usedIn = recipes.filter(r => r.ingredients?.find(i => i.child_pid === recipe.pid)).map(r => r.pid)

    let warnings = []

    if (filter === 'X') {
      if (recipe.meta.emptyIngredientUnits) warnings.push('Some ingredients have no units')
      if (recipe.meta.incorrectUnits) warnings.push(`Invalid unit: ${recipe.meta.incorrectUnits}`)
      if (recipe.meta.mismatched) warnings.push(`Total weight wrong by: ${Math.abs(recipe.meta.mismatchedPerc)}%`)
    }
    return (
      <tr key={`recipe-${recipe.pid}`}>
        <td><b>{recipe.type}:</b>{cleanPID(recipe.pid, recipe.type)}</td>
        <td>{recipe.name}{recipe.desc ? <><br /><span className='sml'>{recipe.desc}</span></> : ''}</td>
        <td>{recipe.display_name}</td>
        {filter === 'X' && <td>{warnings.join(',')}</td>}
        {filter !== 'X' && <td>{allergens?.sort((a, b) => (a > b ? 1 : -1)).map(a => <Allergen key={a} name={a} />)}</td> }
        <td>{recipe.ingredients?.length || '-'}</td>
        <td>{recipe.steps?.length || '-'}</td>
        <td>{usedIn.length ? <button className='inv' onClick={() => history.push(`/spec-cards/USES ${cleanPID(recipe.pid, recipe.type)}`)}>{usedIn.length}</button> : '-'}</td>
        <td>{formatDateWithYear(recipe.last_ordered)}</td>
        <td className='no-wrap right'>{recipe.ingredients?.length ? <button className='inv' onClick={selectRecipe}><FontAwesomeIcon icon={faFile} /></button> : ''}{currentUser.p_speccards >= 2 ? <button className='inv' onClick={editItem}><FontAwesomeIcon icon={faPencilAlt} /></button> : ''}</td>
      </tr>
    )
  }

  


  



  

  




  

  
  const Steps = ({ steps }) => {

    return <div><h3>Method</h3><table className='steps'>{
      steps.map((m, i) => {

        const val = m.txt
        if (!isStep(m)) return (<tr><td></td><td><span className='methodNote'>{val}</span></td></tr>)

        const arr = val.split('|')
        return <tr><td className='methodNum'>{arr[0]}:</td><td>{arr[1]}</td></tr>
      })}</table></div>
  }

  

  const SpecCard = ({ recipe, index, total, parentRecipe, multiplier, random, updateRandom }) => {

    const [expandAll, setExpandAll] = useState(false)

    const [showOriginal, setShowOriginal] = useState(false)

    const selectRecipe = () => {
      history.push(`/spec-cards/${search}/${recipe.pid}`)
    }

    const isSub = recipe.pid !== parentRecipe.pid

    const editItem = () => {
      setItem(recipe)
      toggleEditModal()
    }

    const toggleShowOriginal = () => {
      setShowOriginal(o => !o)
    }

    const showCard = (pid) => {
      history.push(`/spec-cards/${search}/${pid}`)
    }


    if (!recipe.active && isSub) return ''  // dont show archived recipes when subs

    if (recipe.ingredients.length < 1) return ''
    const stepsChars = recipe.steps?.join(' ').length || 0

    let stepsLen = 'lge'
    if (stepsChars < 80 || recipe.ingredients?.length > 8) stepsLen = 'sml'


    const stepsWithPhotos = recipe.steps.filter(s => isStep(s))

    const hasSubRecipes = !!recipe?.ingredients?.find(i => !!i.recipe?.ingredients?.length)
    
    if (!recipes) return ''
    return (
      <div className={`specCard ${mini ? 'mini' : ''}`}>

        {!mini && <Logo />}



        <div className='specCardHeading'>



          <div className='col1'>
            <div className='specCardTop'>



            </div>

            {isSub ? <div className="sub">
              SUB RECIPE {index} OF {total} for {recipeName(parentRecipe).toUpperCase()} ({cleanPID(parentRecipe.pid, parentRecipe.type)})
            </div> : ''}

            <h1>{recipeName(recipe).toUpperCase()} </h1>

            <h4 >{fullRecipeType(recipe.type)} {isSub ? <a href='javascript:void(0)' onClick={selectRecipe}>{cleanPID(recipe.pid, recipe.type)}</a> : <>{cleanPID(recipe.pid, recipe.type)}</>} {recipe.quantity && <> - {showQuantity(recipe.quantity_adjusted, multiplier, recipe.quantity_unit)}</>}</h4>
            <span className='sml' style={{fontStyle:'italic'}}>Created {formatDateWithYear(recipe.created_at)}</span>
            {recipe.video_url && <button onClick={toggleVideoModal} className='inv no-print' style={{ marginTop: 5 }}><FontAwesomeIcon icon={faVideoCamera} /></button>}
          </div>
          <div className='col2'>
            <Photo bucket='recipes' path={cleanPID(recipe.pid, recipe.type)} random={random} onRemove={updateRandom} filename={0} />
          </div>
        </div>

        {recipe.ingredients && recipe.ingredients?.length ?

          <>
            <div className={mini ? 'row' : ''}>
              <div className={`ingredients-column size-${stepsLen}`}>
                <h3 className='ingredients-calc'>Ingredients

                  <div className='ingredients-menu'>

                    {multiplier !== 1 && <button style={{textTransform:'lowercase'}} className={showOriginal ? 'inv' : ''} onClick={toggleShowOriginal}>1x</button>}

                    {hasSubRecipes && <button className='inv' onClick={() => setExpandAll(!expandAll)}><FontAwesomeIcon icon={expandAll ? faMinus : faPlus} /> all</button>}

                    {currentUser.p_speccards >= 2 ? <button className='inv' onClick={editItem}><FontAwesomeIcon icon={faPencilAlt} /></button> : ''}

                  </div>
                </h3>


                <IngredientTable setItem={setItem} showCard={showCard} toggleEditModal={toggleEditModal} canEdit={currentUser.p_speccards >= 2} recipes={recipes} expanded={expandAll} showOriginal={showOriginal} recipe={recipe} multiplier={multiplier} />
              </div>
              {mini && recipe.steps?.length ? <div className={`steps-column size-${stepsLen}`}><Steps steps={recipe.steps} /></div> : ''}

            </div>
          </>
          : ''}

        {!mini && recipe.steps?.length ? <Steps steps={recipe.steps} /> : ''}

        {stepsWithPhotos?.length ? <div className='photo-section'>{stepsWithPhotos.map((m, i) => <Photo key={`${recipe.pid}::${i}`} random={random} onRemove={updateRandom} step={i + 1} filename={i + 1} bucket='recipes' path={cleanPID(recipe.pid, recipe.type)} />)}</div> : ''}

      </div>
    )
  }

  const handleChange = async (updatedRecipe) => {

    const newRecipes = [...recipes.filter(r => r.pid !== updatedRecipe.pid), updatedRecipe]
    setRecipes(newRecipes)

    ELNStore.update(s => { s.recipes = newRecipes })
    const newFilteredRecipes = [...filteredRecipes]
    setFilteredRecipes([...newFilteredRecipes.filter(r => r.pid !== updatedRecipe.pid), updatedRecipe])

 
  }



  

  if (!recipes) return <Loader />

  const countProducts = filteredRecipes.filter(r => r.type === 'P').length
  const countDishes = filteredRecipes.filter(r => r.type === 'D').length
  const countRecipes = filteredRecipes.filter(r => r.type === 'R').length

  let showRecipes = recipesFilteredByType(types, filteredRecipes)

  const withSteps = showRecipes.filter(r => r.steps.length && r.active).length
  const withIngredients = showRecipes.filter(r => r.ingredients.length && r.active).length
  const withActive = showRecipes.filter(r => r.active).length
  const withArchived = showRecipes.filter(r => !r.active).length
  const withWarnings = showRecipes.filter(r => r.meta.hasWarnings).length

  showRecipes = recipesFilteredByOthers(filter, showRecipes)

  const totalRecipesToShow = showRecipes.length

  const pages = (Math.ceil(showRecipes.length / PAGE_SIZE))

  showRecipes = showRecipes.slice(page * PAGE_SIZE, (page+1) * PAGE_SIZE)

  const doPrint = () => {
    window.print()
  }


  const MemoisedCardList = React.memo(
    ({ recipe, allRecipes }) => {

      return <SpecCardList
        recipe={recipe}
        allRecipes={allRecipes}
        random={random}
        updateRandom={updateRandom}
      />
    },
    (prevProps, nextProps) => {
      return ( // make sure this list includes all possible mutatable values
        prevProps.recipe.pid === nextProps.recipe.recipe
      );
    }
  );

  return (

    <div className='outer'>

      {recipe && <Modal
        isShowing={showVideoModal}
        title={recipeName(recipe)}
        hide={toggleVideoModal}
      >
        <iframe className='videoIframe' title="video" frameBorder="0" src={recipe.video_url} />
      </Modal>}

      <Modal
        isShowing={showEditModal}
        title={item ? `Edit ${fullRecipeType(item.type)} ${cleanPID(item.pid, item.type)}` : ''}
        hide={toggleEditModal}
      >
        <RecipeForm toggleModal={toggleEditModal} handleChange={handleChange} defaultItem={item} />
      </Modal>

      <Modal
        isShowing={showLabelModal}
        title='Ingredients Label'
        hide={toggleLabelModal}
      >
        <Label allRecipes={allRecipes} recipes={recipes} recipe={recipe} />
      </Modal>
      
     




      <Modal
        isShowing={showCardModal}
        title='Spec Card'
        hide={toggleCardModal}
      >

        <div className='center no-print'>
          <ul className='button-list'>
            <li className={`inv ${cardView === 'MINI' ? 'selected ' : ''}`}><button onClick={setMini}><FontAwesomeIcon icon={faBars} />  Compact</button></li>
            <li className={`inv ${cardView === 'DEFAULT' ? 'selected' : ''}`}><button onClick={setDefault}><FontAwesomeIcon icon={faFile} />  Page</button></li>
            <li className={`inv ${cardView === 'TRACEABILITY' ? 'selected' : ''}`}><button onClick={setTraceability}><FontAwesomeIcon icon={faListCheck} />  Traceability</button></li>
            <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</li>
            <li><button className='inv' onClick={toggleLabelModal} disabled={excludeSubs.length}><FontAwesomeIcon icon={faReceipt} /> label</button></li>
            <li>{recipe && <LookBook recipes={recipes} allRecipes={allRecipes} recipe={allRecipes.find(r => r.pid === recipe.pid)} />}</li>
            <li><button className='inv' onClick={doPrint}><FontAwesomeIcon icon={faPrint} /> PRINT</button></li>

          </ul>
        </div>




        <div className='specCardList'>
          <MemoisedCardList recipe={recipe} allRecipes={allRecipes} />

        </div>

      </Modal>


      <h1 className='no-print'>Spec Cards</h1>



      <div className='center no-print'>

        <div>
          <DebounceInput disabled={loading} placeholder='search PID or words...' debounceTimeout={3000} className='search' onChange={handleChangeSearch} value={search} />
          
          
        </div>
          <hr/>
            {1 === 5 && <>
            <br/><br/>
            <ul className='button-list'>

              <li className={mthCutoff === 0 ? 'selected' : ''}><button  onClick={() => setMthCutoff(0)}>ALL RECORDS</button></li>
              <li>/</li>
              <li className={mthCutoff === -1 ? 'selected' : ''}><button  onClick={() => setMthCutoff(-1)}>NEVER ORDERED</button></li>
              
              <li>/</li>
              <li>Last ordered within</li>
        
              {[1,2,3,6,12,18,24,36,48,60].map(i => {

                const setMth = () => {
                  setMthCutoff(i)
                }
                return <li className={mthCutoff === i ? 'selected' : ''}><button  onClick={setMth}>{i < 24 ? i : i/12}{(i < 24 ? 'm' : 'y')}</button> </li>
              })}
            </ul>
            </>}

        <ul className='button-list'>

          <li className={types === 'A' ? 'selected' : ''}>
            <button onClick={() => setTypes('A')}>All types: {filteredRecipes?.length}</button>
          </li>
          <li className={types === 'R' ? 'selected' : ''}>
            <button onClick={() => setTypes('R')}>Recipes: {countRecipes}</button>
          </li>
          <li className={types === 'D' ? 'selected' : ''}>
            <button onClick={() => setTypes('D')}>Dishes: {countDishes}</button>
          </li>
          <li className={types === 'P' ? 'selected' : ''}>
            <button onClick={() => setTypes('P')}>Products: {countProducts}</button>
          </li>
        </ul>
        <ul className='button-list'>
          <li className={filter === 'A' ? 'selected' : ''}>
            <button onClick={() => setFilter('A')}>All Active: {withActive}</button>
          </li>
          {types !== 'P' && <><li className={filter === 'S' ? 'selected' : ''}>
            <button onClick={() => setFilter('S')}>With steps: {withSteps}</button>
          </li>
          <li className={filter === 'I' ? 'selected' : ''}>
            <button onClick={() => setFilter('I')}>With Ingredients: {withIngredients}</button>
          </li></>}
          
          <li className={filter === 'V' ? 'selected' : ''}>
            <button onClick={() => setFilter('V')}>Archived: {withArchived}</button>
          </li>

          <li className={filter === 'X' ? 'selected' : ''}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button onClick={() => setFilter('X')}><FontAwesomeIcon icon={faWarning} /> WITH WARNINGS : {withWarnings}</button>
          </li>

        </ul>
        
        {!loading && showRecipes && showRecipes.length ? 
        <Pagination total={totalRecipesToShow} page={page} pages={pages} setPage={setPage} /> : ''
        }

        {!loading && <div style={{fontSize: 13, fontStyle:'italic'}}>{excludeCount} results excluded containing: <a href={'javascript:void(0)'} onClick={toggleExcludeModal}>{exclude ? exclude.split(',').join(', ') : '[set exclusions]'}</a></div>}

        <h3>
            {loading && <>Searching {recipes?.length} items...</>}
            {!loading && !showRecipes.length ? <>No matches. Search again or change filters</> : ''}
        </h3>
      </div>

    
      {loading && <Loader />}

      {!loading && showRecipes.length ?
        <><div style={{ marginTop: '18px' }} className='table-wrapper'><table>
          <tr>
            <th>PID</th>
            <th>Original Name / Desc</th>
            <th>Display Name</th>
            <th>{filter === 'X' ? <><FontAwesomeIcon icon={faWarning} /> Warnings</> : 'Allergens'}</th>
            <th>Ingr.</th>
            <th>Steps</th>
            <th>Used&nbsp;in</th>
            <th>Last&nbsp;order</th>
            <th></th>
          </tr>

          {showRecipes.map(r => (
            <ListRow key={r.pid} recipe={r} />
          ))}
        </table>


        </div>
          {showRecipes.length === MAX_TO_SHOW ? <div className='center'><br /><h4>Only showing first {MAX_TO_SHOW} results.  Please refine search</h4></div> : ''}
        </> : ''}

      <br /><br />
      {!loading && showRecipes && showRecipes.length ? 
        <Pagination total={totalRecipesToShow} page={page} pages={pages} setPage={setPage} /> : ''
        }
      <br /><br />
      <hr/>
      <div className='center'>Recipes last imported: {formatDate(lastImported, true)}</div>
      

      <Modal
        isShowing={showExcludeModal}
        title={'Exclude words from search'}
        hide={updateExclude}
      >
        <div className='excludeModal'>
          <p>Enter words in original name field to exclude from search results, separated by commas.</p>
          <textarea style={{width:'100%', height: 70}} placeholder='e.g. costing' onChange={handleChangeExclude} value={exclude} />
          <button className='inv' onClick={updateExclude}>Save</button>
        </div>
      </Modal>

      <Modal
        isShowing={showCalModal}
        title={'Select date'}
        hide={toggleCalModal}
      >

        {showCalModal && <Calendar
          onChange={handleCalendarChange}
          selectRange={false}
          showDoubleView={false}
          returnValue="start"
          next2Label={null}
          showNeighboringMonth={false}

          prev2Label={null}
        />}

      </Modal>


      
    </div>

  )
}

export default withRouter(SpecCards);
